const GroupIconLoaders = {
    d20: () => import('../media/group_icons/d20.png'),
    meeple_blue: () => import('../media/group_icons/meeple_blue.png'),
    meeple_green: () => import('../media/group_icons/meeple_green.png'),
    meeple_orange: () => import('../media/group_icons/meeple_orange.png'),
    one: () => import('../media/group_icons/one.png'),
    orange_board: () => import('../media/group_icons/orange_board.png'),
    purple_thief: () => import('../media/group_icons/purple_thief.png'),
    red_thief: () => import('../media/group_icons/red_thief.png'),
    skull: () => import('../media/group_icons/skull.png'),
    target: () => import('../media/group_icons/target.png'),
    thinky_person: () => import('../media/group_icons/thinky_person.png'),
    two_dice: () => import('../media/group_icons/two_dice.png'),
    winner_winner: () => import('../media/group_icons/winner_winner.png'),
};

const iconCache = new Map();

export const _getGroupIcon = async (iconName) => {
    const defaultIconModule = await GroupIconLoaders["meeple_orange"]();

    if (!iconName || !GroupIconLoaders[iconName]) {
        return defaultIconModule.default;
    }
    
    // Return cached icon if already loaded
    if (iconCache.has(iconName)) {
        return iconCache.get(iconName);
    }
    
    try {
        // Lazy load the icon
        const iconModule = await GroupIconLoaders[iconName]();
        const iconUrl = iconModule.default;
        
        // Cache it for future use
        iconCache.set(iconName, iconUrl);
        return iconUrl;
    } catch (error) {
        console.error(`Failed to load icon: ${iconName}`, error);
        iconCache.set(iconName, defaultIconModule.default);
        return defaultIconModule.default;
    }
};